import React from "react"
import { Avatar } from "material-ui"
import LogoPlaceholder from "material-ui/svg-icons/device/wallpaper"
import EditIcon from "material-ui/svg-icons/image/edit"
import RemoveIcon from "material-ui/svg-icons/action/delete"
import AppStateStore from "../../../stores/AppStateStore"
import autobind from "class-autobind"
import * as utils from "../../../helpers/utils"
import strings from "../../../localization/strings"
interface IProps {
	readonly?: boolean
	logoUrl: string
	onUploadClientLogo(imageData): void
	onRemoveClientLogo(): void
}
interface IState {
	logo: string
}

export default class AddLogo extends React.Component<IProps, IState>  {
	fileUploader: HTMLInputElement
	constructor(props) {
		super(props)
		this.state = {
			logo: props.logoUrl !== null ? props.logoUrl : ""
		}
		autobind(this)
	}

	async handleFileChange(e) {
		if (!utils.validateImgFileExtension(e.target.files[0])) {
			AppStateStore.setAlertDialogContent({
				title: strings.This_file_format_is_not_supported,
				content: strings.Supported_file_types + ": .png, .jpg, .jpeg"
			})
		} else if (!utils.validateFileSize(e.target.files[0])) {
			AppStateStore.setAlertDialogContent({
				title: strings.This_file_size_is_too_large,
				content: strings.Maximum_File_Size + ": 10 MB"
			})
		} else {
			const imageData = await utils.getBase64(e.target.files[0])
			this.props.onUploadClientLogo(`${imageData}`)
		}
	}

	render() {
		return (
			<div>
				<div><label>{strings.logo}</label></div>
				<Avatar
					style={{ width: 100, height: 100, marginTop: 3, }}
					icon={this.state.logo === "" ? <LogoPlaceholder /> : null}
					src={this.state.logo !== "" ? this.state.logo : ""}
				/>
				{!this.props.readonly && [
					<span title={strings.Upload_Logo} key="upload">
						<EditIcon
							style={{ color: "#95989a", cursor: "pointer", marginBottom: -36 }}
							onTouchTap={() => this.fileUploader.click()}
						/>
					</span>,
					this.state.logo !== null && this.state.logo !== "" &&
					<span title={strings.Remove_Logo} key="remove">
						<RemoveIcon
							style={{ color: "#95989a", cursor: "pointer", marginLeft: -22 }}
							onTouchTap={() => {
								AppStateStore.setConfirmDialogContent({
									content: strings.Are_you_sure_you_want_to_remove_logo,
									confirm: () => {
										this.props.onRemoveClientLogo()
										this.fileUploader.value = null
									}
								})
							}}
						/>
					</span>
				]}
				<input type="file" id="file" onChange={this.handleFileChange} ref={(ref) => this.fileUploader = ref} style={{ display: "none" }} />
			</div>
		)
	}
}